import { CircleX } from "lucide-react";
import React, { useEffect } from "react";
import { createPortal } from 'react-dom';

type ModalType = {
    open?: boolean,
    children: React.ReactNode,
    setClose: () => any,
    title?: string
    description?: string
}

const MiniModal = ({
    open = false,
    children,
    setClose,
    title,
    description
}: ModalType) => {

    // Lock body scroll when modal is open
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        }
    }, [open]);

    return (
        <>
            {open && createPortal(
                <div>
                    <div className="flex overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-[100] justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
                        <div className="relative w-full max-w-lg max-h-full p-4">
                            <div className="relative bg-white rounded-lg shadow p-5">
                                <div>
                                    <h3>{title || "Modal Title"}</h3>
                                    <p>{description}</p>
                                </div>
                                <div className="overflow-auto py-5">
                                    {children}
                                </div>
                                <span className="cursor-pointer absolute top-3 right-5 text-[#E74C3C]" onClick={setClose}><CircleX size={25} /></span>
                            </div>
                        </div>
                    </div>
                    <div className="fixed inset-0 z-50 bg-gray-900/50"></div>
                </div>,
                document.body
            )}
        </>
    );
}

export default MiniModal;
